<template>
  <div class="motto">
    <menuBox :step="4"></menuBox>
    <div class="contentBox">
      <div class="motto-box">
        <p class="bt">Hỗ trợ các hiệu cầm đồ thuộc nhiều ngành nghề thịnh vượng và phát triển</p>
        <div class="btn" @click="step">tìm hiểu thêm</div>
      </div>
      <div class="easiest-box">
        <div class="easiestBt">Các ngành hỗ trợ</div>
        <div class="easiestTitle">Gia đình kinh doanh dịch vụ cầm đồ XIN TU PAWNSHOP SERVICES BUSINESS HOUSEHOLD hỗ trợ các hiệu cầm đồ ở nhiều ngành khác nhau
          và giúp phát triển các ngành khác nhau.</div>
        <div class="mission">
          <div class="mission-box">
            <div class="item">
              <img src="../assets/better1.png" alt="">
              <p>Dịch vụ cầm đồ ngành ô tô</p>
            </div>
            <div class="item">
              <img src="../assets/better2.png" alt="">
              <p>Dịch vụ cầm đồ cho ngành may mặc</p>
            </div>
            <div class="item">
              <img src="../assets/better3.png" alt="">
              <p>Dịch vụ cầm đồ trong lĩnh vực bất động sản</p>
            </div>
          </div>
          <div class="mission-box">
            <div class="item">
              <img src="../assets/better4.png" alt="">
              <p>Dịch vụ cầm đồ ngành nghệ thuật</p>
            </div>
            <div class="item">
              <img src="../assets/better5.png" alt="">
              <p>Dịch vụ cầm đồ ngành kim loại quý</p>
            </div>
            <div class="item">
              <img src="../assets/better6.png" alt="">
              <p>Dịch vụ cầm đồ cho ngành trang sức</p>
            </div>
          </div>
        </div>
      </div>
      <div class="discount">
        <div class="title">
          Đôi nét về nghề cầm đồ
        </div>
        <div class="text">Tìm hiểu thêm về sự phát triển của công ty</div>
        <div class="btn">
          <span @click="step" style="cursor: pointer;">tìm hiểu thêm</span>
        </div>
      </div>
      <footerBox></footerBox>
    </div>
  </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
  name: "App",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {
      val: ''
    };
  },
  mounted() { },
  methods: {
    step() {
      this.$router.push({ path: "contact" });
    },
  },
};
</script>
<style lang="less" scoped>
.motto {
  display: flex;

  .contentBox {
    flex: 1;
    overflow: hidden;
  }
}

.motto-box {
  background-image: url(../assets/contact.png);
  width: 100%;
  height: 700px;
  background-size: 100% 100%;
  padding: 222px 72px 0 72px;
  position: relative;
  box-sizing: border-box;

  .bt {
    margin-bottom: 27px;
    font-size: 72px;
    font-family: Arial, Arial;
    font-weight: 900;
    color: #FFFFFF;
    line-height: 101px;
  }

  .btn {
    display: table;
    cursor: pointer;
    padding: 15px 26px;
    font-size: 16px;
    font-family: Arial, Arial;
    font-weight: normal;
    color: #FFFFFF;
    background: #C9292E;
    border-radius: 24px;
  }
}

.easiest-box {
  margin: 100px 72px;

  .easiestBt {
    margin-bottom: 24px;
    font-size: 40px;
    font-family: Arial, Arial;
    font-weight: 900;
    color: #333333;
    line-height: 56px;
  }

  .easiestTitle {
    font-size: 20px;
    font-family: ArialMT;
    color: #999999;
    line-height: 32px;
  }

  .mission {
    margin-top: 40px;

    .mission-box {
      display: flex;
      margin-bottom: 48px;

      .item {
        position: relative;
        margin-right: 48px;

        img {
          width: 400px;
          height: 500px;
        }

        p {
          position: absolute;
          bottom: 30px;
          left: 30px;
          width: 340px;
          font-size: 24px;
          font-family: Arial, Arial;
          font-weight: normal;
          color: #FFFFFF;
          line-height: 28px;
        }
      }

      .item:nth-child(3) {
        margin-right: 0;
      }
    }

  }


}

.discount {
  width: 100%;
  background-image: url(../assets/privacyImg.png);
  height: 480px;
  background-size: 100% 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .title {
    margin-bottom: 5px;
    font-size: 48px;
    font-family: Arial, Arial;
    font-weight: 900;
    color: #C9292E;
    line-height: 68px;
  }

  .text {
    margin-bottom: 24px;
    font-size: 20px;
    font-family: ArialMT;
    color: #FFFFFF;
  }

  .btn {

    span {
      display: table;
      padding: 16px 27px;
      background: #DBA35C;
      border-radius: 24px;
      font-size: 16px;
      font-family: Arial, Arial;
      font-weight: normal;
      color: #333333;
    }
  }
}
</style>
  